/* eslint-disable react-hooks/exhaustive-deps */
import React from "react"
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"

import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"
import { RootState } from "../../../globalStore/rootreducer"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import dateUtil from "../../../ts/util/dateUtil"
import _ from "lodash"
import {
  TTukekaeZissekiListByNendoGetReq,
  TTukekaeZissekiListGetReq,
  T付替実績,
} from "../../../service/budget/tukekaeZissekiList/TTukekaeZissekiList"
import TukekaeZissekiListService from "../../../service/budget/tukekaeZissekiList/tukekaeZissekiListService"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import TukekaeZissekiUtiwakeModal from "./TukekaeZissekiUtiwakeModal"

export type T集計データ = {
  部所ID: number
  部所コード: string
  部所略称: string
  自部所受注自部所運行_金額: number
  自部所受注自部所運行_稼働台数: number
  自部所受注他部所運行_金額: number
  自部所受注他部所運行_稼働台数: number
  他部所受注自部所運行_金額: number
  他部所受注自部所運行_稼働台数: number
  自部所受注自部所運行List: T付替実績[]
  自部所受注他部所運行List: T付替実績[]
  他部所受注自部所運行List: T付替実績[]
}

type TQueryString = TTukekaeZissekiListGetReq & {
  年度検索フラグ?: string
}

/**
 * 付替実績一覧
 * @returns
 */
const TukekaeZissekiList = () => {
  const history = useHistory()
  const location = useLocation()

  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)
  const 当年度 = dateUtil.to年度(営業日)

  //TODO:ページ名称確定必須
  let gridId = "tukekaeZissekiList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T付替実績>, pageSize: number) => {
    let 集計データList: T集計データ[] = []
    const 部所List = _.uniqBy(data, "受注部所ID").map((d) => ({
      部所ID: d.受注部所ID,
      部所コード: d.受注部所コード,
      部所略称: d.受注部所略称,
    }))

    for (let key in 部所List) {
      const 部所 = 部所List[key]

      const 自部所受注自部所運行List = data.filter(
        (d) => d.受注部所ID === 部所.部所ID && d.運行部所ID === 部所.部所ID
      )
      const 自部所受注他部所運行List = data.filter(
        (d) => d.受注部所ID === 部所.部所ID && d.運行部所ID !== 部所.部所ID
      )
      const 他部所受注自部所運行List = data.filter(
        (d) => d.受注部所ID !== 部所.部所ID && d.運行部所ID === 部所.部所ID
      )
      const 自部所受注自部所運行_金額 = _.sumBy(
        自部所受注自部所運行List,
        (d) => d.金額 ?? 0
      )
      const 自部所受注自部所運行_稼働台数 = _.sumBy(
        自部所受注自部所運行List,
        (d) => d.配車件数 ?? 0
      )
      const 自部所受注他部所運行_金額 = _.sumBy(
        自部所受注他部所運行List,
        (d) => d.金額 ?? 0
      )
      const 自部所受注他部所運行_稼働台数 = _.sumBy(
        自部所受注他部所運行List,
        (d) => d.配車件数 ?? 0
      )

      const 他部所受注自部所運行_金額 = _.sumBy(
        他部所受注自部所運行List,
        (d) => d.金額 ?? 0
      )
      const 他部所受注自部所運行_稼働台数 = _.sumBy(
        他部所受注自部所運行List,
        (d) => d.配車件数 ?? 0
      )

      const 集計データ: T集計データ = {
        ...部所,
        自部所受注自部所運行_金額,
        自部所受注自部所運行_稼働台数,
        自部所受注他部所運行_金額,
        自部所受注他部所運行_稼働台数,
        他部所受注自部所運行_金額,
        他部所受注自部所運行_稼働台数,
        自部所受注自部所運行List,
        自部所受注他部所運行List,
        他部所受注自部所運行List,
      }

      集計データList.push(集計データ)
    }
    集計データList = _.orderBy(集計データList, ["部所コード"], ["asc"])

    return new wjCore.CollectionView(集計データList, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const 年度search = async (
    searchCondition?: TTukekaeZissekiListByNendoGetReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TTukekaeZissekiListByNendoGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    try {
      const res = 年度検索フラグ
        ? await new TukekaeZissekiListService().getListBy年度(
            currentSearchCondition
          )
        : await new TukekaeZissekiListService().getList(currentSearchCondition)

      //表示用の検索条件を作成
      setDisplaySearchCondition(
        createDisplaySearchCondition(currentSearchCondition)
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = (): TTukekaeZissekiListGetReq => {
    const query: TQueryString = queryString.parse(location.search)
    set年度検索フラグ(query.年度 != null)
    const 年度Inner = query.年度 as unknown as string
    const int年度Inner =
      wjCore.isNullOrWhiteSpace(年度Inner ?? "") &&
      Number.isNaN(parseInt(年度Inner ?? ""))
        ? 当年度
        : parseInt(年度Inner ?? "")
    set年度(int年度Inner)
    query.年月 && set年月(query.年月)
    return {
      年度: int年度Inner,
      年月: query.年月,
    }
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TTukekaeZissekiListGetReq => {
    return {
      年度: 年度検索フラグ ? 年度 ?? undefined : undefined,
      年月: !年度検索フラグ ? 年月 ?? undefined : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TTukekaeZissekiListGetReq
  ) => {
    return {
      年度: 年度検索フラグ
        ? searchCondition.年度 != null
          ? `${searchCondition.年度}年度`
          : undefined
        : undefined,
      年月:
        !年度検索フラグ && searchCondition.年月
          ? dateUtil.format(searchCondition.年月, "YYYY/MM")
          : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {}

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    mergeHeader(grid)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""

        if (c.binding.includes("自部所受注自部所運行")) {
          setHeaderText = "自部所受注・運行"
        } else if (c.binding.includes("自部所受注他部所運行")) {
          setHeaderText = "自部所受注・他部所運行"
        } else if (c.binding.includes("他部所受注自部所運行")) {
          setHeaderText = "他部所受注・自部所運行"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
        if (r === 0 && cell.textContent?.includes("運行")) {
          cell.style.textAlign = "center"
        } else {
          cell.style.textAlign = ""
        }
      }
    }
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年度, set年度] = useState<number | null | undefined>(当年度)
  const [年月, set年月] = useState<string | null | undefined>(営業日)

  const [年度検索フラグ, set年度検索フラグ] = useState(true)
  // 年度
  const [年度ComboBox, set年度ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)
  const [年度isLoadEnded, set年度isLoadEnded] = useState<boolean>(false)

  const [isModalShow, setIsModalShow] = useState(false)
  const [集計データ, set集計データ] = useState<T集計データ>()
  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        年度search(querySearchCondition)
      } else {
        set年度(当年度)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">付替実績一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div
                              className="me-2"
                              style={{
                                alignItems: "center",
                                marginBlock: "auto",
                                height: "100%",
                              }}>
                              <Button
                                type="button"
                                variant={
                                  年度検索フラグ ? "success" : "outline-success"
                                }
                                disabled={isSearching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  set年度検索フラグ(true)
                                }}>
                                年度
                              </Button>
                            </div>
                            <div className="w-8rem">
                              <YearComboBox
                                placeholder="年度"
                                isDisabled={!年度検索フラグ || isSearching}
                                is年度={true}
                                isLoadEnded={年度isLoadEnded}
                                isRequired={false}
                                setIsLoadEnded={set年度isLoadEnded}
                                selectedValue={年度}
                                setSelectedValue={(v) => {
                                  set年度(v)
                                }}
                                ComboBox={年度ComboBox}
                                setComboBox={set年度ComboBox}></YearComboBox>
                            </div>
                            <div
                              className="ms-4"
                              style={{
                                alignItems: "center",
                                marginBlock: "auto",
                                height: "100%",
                              }}>
                              <Button
                                type="button"
                                variant={
                                  !年度検索フラグ
                                    ? "success"
                                    : "outline-success"
                                }
                                disabled={isSearching}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  e.preventDefault()
                                  set年度検索フラグ(false)
                                }}>
                                年月
                              </Button>
                            </div>
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                isDisabled={年度検索フラグ || isSearching}
                                defaultValue={営業日}
                                setValue={set年月}
                                isRequired={true}
                                placeholder="年月"
                                autoFocus={true}
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                年度search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  binding="部所コード"
                  width={100}
                  sortMemberPath={"所属部所コード"}>
                  <EmptyTextHeader />
                  <wjrGrid.FlexGridCellTemplate
                    cellType={wjrGrid.CellTemplateType.Cell}
                    template={(
                      context: TWijmoCellTemplateContext<T集計データ>
                    ) => (
                      <Button
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          set集計データ(context.item)
                          setIsModalShow(true)
                        }}>
                        付替内訳
                      </Button>
                    )}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  width={160}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="自部所受注自部所運行_金額"
                  width={160}
                  header="金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="自部所受注自部所運行_稼働台数"
                  width={160}
                  header="稼働台数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="自部所受注他部所運行_金額"
                  width={160}
                  header="金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="自部所受注他部所運行_稼働台数"
                  width={160}
                  header="稼働台数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="他部所受注自部所運行_金額"
                  width={160}
                  header="金額"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="他部所受注自部所運行_稼働台数"
                  width={160}
                  header="稼働台数"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <TukekaeZissekiUtiwakeModal
        isShow={isModalShow}
        setIsShow={setIsModalShow}
        集計データ={集計データ}></TukekaeZissekiUtiwakeModal>
    </Container>
  )
}

export default TukekaeZissekiList
